var FAQAutoSuggestionListView, FAQV1AutoSuggestionListView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FAQAutoSuggestionListView = require('./autosuggestionlist');

FAQV1AutoSuggestionListView = (function(superClass) {
  extend(FAQV1AutoSuggestionListView, superClass);

  function FAQV1AutoSuggestionListView() {
    return FAQV1AutoSuggestionListView.__super__.constructor.apply(this, arguments);
  }

  FAQV1AutoSuggestionListView.prototype.initialize = function() {
    return FAQAutoSuggestionListView.prototype.initialize.apply(this, arguments);
  };

  FAQV1AutoSuggestionListView.prototype.renderNoSuggestions = function(keyword, status) {
    return Groupon.FAQ.ViewManager.renderErrorHtml({
      container: this.errorContainer,
      query: keyword,
      errorHtmlText: "<div data-bhw='faq___" + (encodeURIComponent(keyword)) + "___no-results-displayed-for-autocomplete-api-" + status + "' class='noResults'>" + (I18n.t('js.modules.faq.not_found')) + "</div>"
    });
  };

  FAQV1AutoSuggestionListView.prototype.renderSuggestions = function(response) {
    var ref;
    this.renderBreadCrumbs(response.query, (I18n.t('js.modules.faq.search_result')) + "'" + response.query + "'");
    if ((response != null ? (ref = response.docs) != null ? ref.length : void 0 : void 0) > 0) {
      this.toHtml();
      return this.renderSuggestionElements(response);
    } else {
      return this.renderNoSuggestions(response.query, 'success');
    }
  };

  return FAQV1AutoSuggestionListView;

})(FAQAutoSuggestionListView);

module.exports = FAQV1AutoSuggestionListView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL3ZpZXdzL3YxX2F1dG9zdWdnZXN0aW9ubGlzdC5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9mYXEvZnJvbnRlbmQvdmlld3MvdjFfYXV0b3N1Z2dlc3Rpb25saXN0LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHNEQUFBO0VBQUE7OztBQUFBLHlCQUFBLEdBQTRCLE9BQUEsQ0FBUSxzQkFBUjs7QUFFckI7Ozs7Ozs7d0NBRUwsVUFBQSxHQUFZLFNBQUE7V0FDVix5QkFBeUIsQ0FBQSxTQUFFLENBQUEsVUFBVSxDQUFDLEtBQXRDLENBQTRDLElBQTVDLEVBQWtELFNBQWxEO0VBRFU7O3dDQUdaLG1CQUFBLEdBQXFCLFNBQUMsT0FBRCxFQUFVLE1BQVY7V0FDbkIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsZUFBeEIsQ0FBd0M7TUFDdEMsU0FBQSxFQUFZLElBQUMsQ0FBQSxjQUR5QjtNQUV0QyxLQUFBLEVBQVEsT0FGOEI7TUFHdEMsYUFBQSxFQUFnQix1QkFBQSxHQUF1QixDQUFDLGtCQUFBLENBQW1CLE9BQW5CLENBQUQsQ0FBdkIsR0FBb0QsK0NBQXBELEdBQW1HLE1BQW5HLEdBQTBHLHNCQUExRyxHQUErSCxDQUFDLElBQUksQ0FBQyxDQUFMLENBQU8sMEJBQVAsQ0FBRCxDQUEvSCxHQUFtSyxRQUg3STtLQUF4QztFQURtQjs7d0NBT3JCLGlCQUFBLEdBQW1CLFNBQUMsUUFBRDtBQUNqQixRQUFBO0lBQUEsSUFBQyxDQUFBLGlCQUFELENBQW1CLFFBQVEsQ0FBQyxLQUE1QixFQUFxQyxDQUFDLElBQUksQ0FBQyxDQUFMLENBQU8sOEJBQVAsQ0FBRCxDQUFBLEdBQXdDLEdBQXhDLEdBQTJDLFFBQVEsQ0FBQyxLQUFwRCxHQUEwRCxHQUEvRjtJQUNBLDJEQUFpQixDQUFFLHlCQUFoQixHQUF5QixDQUE1QjtNQUNFLElBQUMsQ0FBQSxNQUFELENBQUE7YUFDQSxJQUFDLENBQUEsd0JBQUQsQ0FBMEIsUUFBMUIsRUFGRjtLQUFBLE1BQUE7YUFJRSxJQUFDLENBQUEsbUJBQUQsQ0FBcUIsUUFBUSxDQUFDLEtBQTlCLEVBQXFDLFNBQXJDLEVBSkY7O0VBRmlCOzs7O0dBWnNCOztBQW9CM0MsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
